import React, { useEffect } from "react";
import { Form, Input, Select, InputNumber } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingModuleDetails, doTrainingModuleCreate, doTrainingModuleUpdate 
} from "../../../../redux/trainingmodule/trainingModuleState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { getLabel } from "utils";
import { MODULE_TRAINING_MOD } from "variables/constants"

const TrainingModuleForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;  	

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	useEffect(() => {
		if(recordData){
			form.resetFields();
			const { trainingmodule:trm_title, trm_question_items, ...rest } = recordData;

			const initialValues = {
				...rest,
				trm_id: recordData?.trm_id ?? "",
				trm_title: recordData?.trm_title ?? "",
			    trm_question_items: recordData?.trm_question_items ?? "",
				trm_passing_score: recordData?.trm_passing_score ?? "",
				trm_client_id: recordData?.trm_client_id ?? "",
				trm_status_id: recordData?.trm_status_id ?? "",
				trm_allowed_attempt: recordData?.trm_allowed_attempt ?? "",
			};
	        form.setFieldsValue(initialValues);

        }
    }, [recordData, form]);


  	const onSubmit = (formData) => {	
		console.log(recordData);
    	try {  

			recordData.trm_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className={mode !== "view" ? "form" : ""}
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="trm_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			
			<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">         		            	            
				<FormItem className="font-medium mb-2 col-span-3"
					name="trm_title"
					label="Training Module Title"
					rules={[requiredField]}
					
				>
					{mode === 'edit' ?
					<Input id="trm_title"
						className="input-field"
						maxLength={100}
						placeholder="Enter training module title"
					/>
					: <label className="text-base label-value dark:text-white">{recordData?.trm_title}</label>
					}
				</FormItem>	  
				<FormItem className="font-medium mb-2 "
					name="trm_question_items"
					label="Question Items"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<InputNumber
					id="trm_question_items"
					className="input-field w-full [&>input]:text-right"
					min={1}
					style={{ width: '100%', textAlign: 'right' }}
					placeholder="Number of questions"
					/>
					: <label className="text-base label-value dark:text-white">{recordData?.trm_question_items}</label>
					}               
				</FormItem> 
				<FormItem className="font-medium mb-2 "
					name="trm_passing_score"
					label="Passing Score"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<InputNumber
					id="trm_passing_score"
					className="input-field"
					min={1}
					max={100}
					addonAfter="%"
					style={{ width: '100%' }}
					placeholder="Passing score"
					/>
					: <label className="text-base label-value dark:text-white">{recordData?.trm_passing_score}</label>
					}               
				</FormItem> 
			<FormItem className="font-medium mb-2 "
					name="trm_allowed_attempt"
					label=" Allowed Attempts "
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<InputNumber
					id="trm_allowed_attempt"
					className="input-field w-full [&>input]:text-right"
					min={1}
					style={{ width: '100%', textAlign: 'right' }}
					placeholder="Number of attempts"
					/>
					: <label className="text-base label-value dark:text-white">{recordData?.trm_allowed_attempt}</label>
					}               
				</FormItem> 
				
				<FormItem
					label="Client"
					name="trm_client_id"
				>
					{mode !== "view" ? 
						<Select id="trm_client_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.clientList}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.clientList, recordData?.trm_client_id)}
						</label>
					}
				</FormItem>
			</div>


			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
					mode={mode}
					recordId={recordData?.trm_id ?? 0}
					isModal={true}
					modalId={recordData?.trm_id > 0 ? 'edit_trainingModule' : 'add_trainingModule'}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
					moduleId={MODULE_TRAINING_MOD}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingModule.trainingModuleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getTrainingModuleDetails(id)),
  	doCreate: (data) => dispatch(doTrainingModuleCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingModuleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleForm);
